import { TourOrder, Trailer } from "../queries/api/types";

interface FormatTrailerNameParams {
    trailerReference?: TourOrder["computedProperties"]["trailerReference"] | Trailer["reference"];
    trailerRegistration?: TourOrder["computedProperties"]["trailerRegistration"] | Trailer["registration"];
    trailerCreatedInTourOrder?:
        | TourOrder["computedProperties"]["trailerCreatedInTourOrder"]
        | Trailer["createdInTourOrder"];
}

export const formatTrailerName = ({
    trailerReference,
    trailerRegistration,
    trailerCreatedInTourOrder,
}: FormatTrailerNameParams) => {
    if (!trailerReference && !trailerRegistration) {
        return "-";
    }
    if (trailerCreatedInTourOrder) {
        return trailerRegistration || "-";
    }
    return [trailerReference, trailerRegistration && `(${trailerRegistration})`].filter(Boolean).join(" ");
};
